import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../redux/slice/authSlice';
import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';
import logo from '../assets/logo.png';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import LoadingComponent from '../components/LoadingComponent';

const Login = () => {
  const dispatch = useDispatch();
  const authState = useSelector(state => state.auth);
  const { status = 'idle', error = null } = authState;
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // Ανακτά το isAdmin απευθείας από το token κάθε φορά που το Login component χρειάζεται να κάνει check
  const isAdmin = (() => {
    const tokenAccess = Cookies.get('tokenAccess');
    if (tokenAccess) {
      const decodedToken = jwtDecode(tokenAccess);
      return decodedToken.is_admin;
    }
    return false;
  })();

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(login({ username, password }));
  };

  // Ανακατεύθυνση βασισμένη στο `isAdmin`
  const tokenRefresh = Cookies.get('tokenRefresh');
  if (tokenRefresh && isAdmin) {
    return <Navigate to="/admin" replace />;
  } else if (tokenRefresh) {
    return <Navigate to="/user" replace />;
  }

  return (<>
  {status === 'loading' ? <LoadingComponent/> :
    (<Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100dvh' }}>
      <Row className="w-100">
        <Col md={6} lg={4} className="mx-auto p-4" style={{ backgroundColor: '#ffffff', borderRadius: '15px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
          <div className="text-center mb-4">
            <img src={logo} alt="Logo" style={{ width: '150px', borderRadius: '10%' }} />
          </div>
          <h4 className="text-center mb-1" style={{ fontWeight: '600' }}>Λ.Α.Φ. Αλεξανδρούπολης</h4>
          <h5 className="text-center mb-4" style={{ fontWeight: '300', color: 'gray' }}>Ηλεκτρονική Εφαρμογή Παραγγελιών</h5>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="username" className="mb-3">
              <Form.Label>Όνομα Χρήστη</Form.Label>
              <Form.Control
                type="text"
                placeholder="Εισαγάγετε όνομα χρήστη"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete='off'
                autoCorrect='off'
                autoCapitalize='off'
                spellCheck='false'
                style={{ borderRadius: '8px' }}
              />
            </Form.Group>
            <Form.Group controlId="password" className="mb-3">
              <Form.Label>Κωδικός Πρόσβασης</Form.Label>
              <Form.Control
                type="password"
                placeholder="Εισαγάγετε κωδικό πρόσβασης"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ borderRadius: '8px' }}
              />
            </Form.Group>
            <Button
              variant="warning"
              type="submit"
              className="w-100"
              style={{ backgroundColor: '#2196f3', color: 'white', borderRadius: '8px', fontWeight: 'bold', border: 'none', padding: '10px' }}
            >
              <strong>Είσοδος</strong>
            </Button>
          </Form>
          {status === 'loading' && (
            <div className="text-center mt-3">
              <Spinner animation="border" variant="secondary" />
            </div>
          )}
          {status === 'failed' && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  )
}
  </>
  );
};

export default Login;
